export default __webpack_public_path__ + "static/media/female.c8f9e6c0.png";